import KeywordsOwner from './keywords_owner';

import Model from "backdraft-app/src/model";

import $ from "jquery";

export default class Keyword extends Model {
  trimName() {
    const name = $.trim(this.get('name'));
    this.set('name', name);
  }

  phraseWithSpeaker() {
    if (this.get('name')) {
      return this.get('name') + (this._isSpecificSpeaker() ? this._speakerInParens() : "");
    } else {
      return "";
    }
  }

  phraseWithSpeakerAsText() {
    return `"${this.phraseWithSpeaker()}"`;
  }

  _speakerInParens() {
    return ` (${this.get('speaker')})`;
  }

  _isSpecificSpeaker() {
    return this.get('speaker') && this.get('speaker') !== (new KeywordsOwner().defaultSpeaker);
  }
}
